export const SET_ASK = "SET_ASK";

export const ASK_ANSWER = "ASK_ANSWER";

export const ANSWER_QUESTION = "ANSWER_QUESTION";

export const ASK_INITIAL = "ASK_INITIAL";

export const ASK_EMPTY_ANSWERS = "ASK_EMPTY_ANSWERS";
